import request from '@/utils/request'
import axios from 'axios'

// 查看停车积分抵扣配置
export async function api_getParkingConfig(params) {
  return request({
    url: '/rest/parking/config',
    method: 'get',
    params,
    loading: true
  })
}
// 查看停车规则
export async function api_getParkingConfigRule(params) {
  return request({
    url: '/rest/parking/config/rule',
    method: 'get',
    params,
    loading: true
  })
}
// 编辑停车积分抵扣配置
export async function api_putParkingConfig(data) {
  return request({
    url: '/rest/parking/config',
    method: 'put',
    data,
  })
}
// 编辑停车规则
export async function api_putParkingConfigRule(data) {
  return request({
    url: '/rest/parking/config/rule',
    method: 'put',
    data,
  })
}

// 停车缴费记录详情
export async function api_getParkingRecord(params) {
  return request({
    url: '/rest/parking/bill/detail',
    method: 'get',
    params,
    loading: true
  })
}
// 停车缴费记录列表
export async function api_getParkingRecordList(params) {
  return request({
    url: '/rest/parking/bill/list',
    method: 'get',
    params,
  })
}
// 停车规则列表
export async function api_getParkingConfigList(params) {
  return request({
    url: '/rest/parking/config/list',
    method: 'get',
    params,
  })
}
// 新增时获取基础配置信息
export async function api_getParkingConfigLevel(params) {
  return request({
    url: '/rest/parking/config/level',
    method: 'get',
    params,
  })
}
// 获取车场列表
export async function api_getParkingLotList(params) {
  return request({
    url: '/rest/parking/lot/list',
    method: 'get',
    params,
  })
}

// 查看车场详情
export async function api_getParkingLot(params) {
  return request({
    url: '/rest/parking/lot',
    method: 'get',
    params,
  })
}
// 新增车场
export async function api_postParkingLot(data) {
  return request({
    url: '/rest/parking/lot',
    method: 'post',
    data,
  })
}
// 编辑车场
export async function api_putParkingLot(data) {
  return request({
    url: '/rest/parking/lot',
    method: 'put',
    data,
  })
}
// 获取会员权益基础配置
export async function api_getParkingMemberDiscount(params) {
  return request({
    url: '/rest/parking/member/discount',
    method: 'get',
    params,
  })
}
// 编辑会员权益
export async function api_postParkingMemberDiscount(data) {
  return request({
    url: '/rest/parking/member/discount',
    method: 'post',
    data,
  })
}
// 获取支付店铺列表
export async function api_getParkingStoreList(params) {
  return request({
    url: '/rest/parking/store',
    method: 'get',
    params,
  })
}
// 获取车场供应商列表
export async function api_getParkingLotSupplierList(params) {
  return request({
    url: '/rest/parking/lot/supplier/listAll',
    method: 'get',
    params,
  })
}
// 获取积分抵扣规则详情
export async function api_getParkingPointDetail(params) {
  return request({
    url: '/rest/parking/point',
    method: 'get',
    params,
  })
}
// 编辑
export async function api_putParkingPointDetail(data) {
  return request({
    url: '/rest/parking/point',
    method: 'put',
    data,
  })
}

// 获取停车券模版
export async function api_getParkingCouponTemplate(params) {
  return request({
    url: '/rest/parking/coupon/template/available',
    method: 'get',
    params,
  })
}
// 获取停车券模版详情已拼
export async function api_getParkingCouponDetail(params) {
  return request({
    url: '/rest/parking/coupon/template/brief',
    method: 'get',
    params,
  })
}
// 获取发票说明及常见问题
export async function api_getInvoiceQuestion(params) {
  return request({
    url: '/rest/invoice/explain/page',
    method: 'get',
    params,
  })
}
// 更新发票说明及常见问题
export async function api_postInvoiceQuestion(data) {
  return request({
    url: ' /rest/invoice/explain/updateById',
    method: 'post',
    data,
  })
}
// 开票列表
export async function api_getInvoiceList(params) {
  return request({
    url: '/rest/invoice/page',
    method: 'get',
    params,
  })
}

/************************************订单明细*******************************************/

// 获取订单明细列表
export async function api_getParkingOrderDetailsPage(params) {
  return request({
    url: '/rest/parking/order/page',
    method: 'get',
    params,
  })
}

// 订单明细导出
export async function api_getParkingOrderDetailsExport(params) {
  return request({
    url: '/rest/parking/order/download',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
// 更新发票入口状态接口
export async function api_postUpdateInvoiceEntrance(data) {
  return request({
    url: '/rest/invoice/explain/updateInvoiceEntrance',
    method: 'post',
    data,
  })
}